document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__description-wrapper').forEach(function (wrapper) {
    var description = wrapper.querySelector('.product__description');
    var button = wrapper.querySelector('.product__description-toggle');
    if (!description || !button) return;

    if (description.scrollHeight <= description.clientHeight + 5) {
      button.style.display = 'none';
      return;
    }

    button.addEventListener('click', function () {
      var expanded = wrapper.classList.toggle('is-expanded');
      button.textContent = expanded ? 'Ler menos' : 'Ler mais...';
      button.setAttribute('aria-expanded', expanded);
    });
  });
});